import React from "react";
import PropTypes from "prop-types";
import SectionItem from "./SectionItem.jsx";
import SummaryItem from "./SummaryItem.jsx";

export default class Area extends React.Component {
  getAreaIdName = (areaId) => {
    const area = this.props.areaPlans.find((areaKey) => areaKey.id === areaId);
    return area ? area.name : areaId;
  };

  getMobileAreaIdName = (areaId) => {
    const area = this.props.mobileAreaPlans.find(
      (areaKey) => areaKey.id === areaId,
    );
    return area ? area.name : areaId;
  };

  getPostcdAreaIdName = (areaId) => {
    const area = this.props.postcdAreaPlans.find(
      (areaKey) => areaKey.id === areaId,
    );
    return area ? area.name : areaId;
  };

  renderAreaEntries = (moduleList) => {
    const menuEntries = moduleList.map((module, index) => {
      return (
        <SummaryItem
          key={index}
          itemKey={`${this.getAreaIdName(module.areaPlanAreaId)} - ${
            module.moduleGroup.name
          }`}
        >
          {this.props.renderContent(module.moduleGroup, this.props.sites, true)}
        </SummaryItem>
      );
    });

    return menuEntries;
  };

  renderDefaultAreaEntries = (moduleList) => {
    const menuEntries = moduleList.map((module, index) => {
      return (
        <SummaryItem key={index} itemKey={module.moduleGroup.name}>
          {this.props.renderContent(module.moduleGroup, this.props.sites, true)}
        </SummaryItem>
      );
    });

    return menuEntries;
  };

  renderMobileAreaEntries = (moduleList) => {
    const menuEntries = moduleList.map((module, index) => {
      return (
        <SummaryItem
          key={index}
          itemKey={`${this.getMobileAreaIdName(module.areaPlanAreaId)} - ${
            module.moduleGroup.name
          }`}
        >
          {this.props.renderContent(module.moduleGroup, this.props.sites, true)}
        </SummaryItem>
      );
    });

    return menuEntries;
  };

  renderPostcdAreaEntries = (moduleList) => {
    const menuEntries = moduleList.map((module, index) => {
      return (
        <SummaryItem
          key={index}
          itemKey={`${this.getPostcdAreaIdName(module.areaPlanAreaId)} - ${
            module.moduleGroup.name
          }`}
        >
          {this.props.renderContent(module.moduleGroup, this.props.sites, true)}
        </SummaryItem>
      );
    });

    return menuEntries;
  };

  render = () => {
    const { areaModule } = this.props;
    return (
      <span>
        {areaModule.defaultAreaPlanOption && (
          <SectionItem itemKey="Default">
            <span style={{ fontSize: "0.8em" }}>
              {this.renderDefaultAreaEntries([
                areaModule.defaultAreaPlanOption,
              ])}
            </span>
          </SectionItem>
        )}
        {areaModule.defaultAreaPlanOption ? (
          <SectionItem itemKey="Geographic">
            <span style={{ fontSize: "0.8em" }}>
              {this.renderAreaEntries(areaModule.areaPlanOptionList)}
            </span>
          </SectionItem>
        ) : (
          <SectionItem itemKey="">
            <span style={{ fontSize: "0.8em" }}>
              {this.renderAreaEntries(areaModule.areaPlanOptionList)}
            </span>
          </SectionItem>
        )}
        {areaModule.mobileAreaPlanOptionList &&
          areaModule.mobileAreaPlanOptionList.length > 0 && (
            <SectionItem itemKey="Mobile">
              <span style={{ fontSize: "0.8em" }}>
                {this.renderMobileAreaEntries(
                  areaModule.mobileAreaPlanOptionList,
                )}
              </span>
            </SectionItem>
          )}
        {areaModule.postcdAreaPlanOptionList &&
          areaModule.postcdAreaPlanOptionList.length > 0 && (
            <SectionItem itemKey="PostCode">
              <span style={{ fontSize: "0.8em" }}>
                {this.renderPostcdAreaEntries(
                  areaModule.postcdAreaPlanOptionList,
                )}
              </span>
            </SectionItem>
          )}
      </span>
    );
  };
}

Area.propTypes = {
  renderContent: PropTypes.func,
  areaModule: PropTypes.object,
  sites: PropTypes.array,
  areaPlans: PropTypes.array,
  mobileAreaPlans: PropTypes.array,
  postcdAreaPlans: PropTypes.array,
};
